import React from 'react';

import { useTranslation } from '../../../../../hooks';
import { T } from '../../../../../constants';

interface RewardsDetailedPopupHeaderProps {
  onClose: () => void;
}

export const RewardsDetailedPopupHeader: React.FC<RewardsDetailedPopupHeaderProps> = ({ onClose }) => {

  const t = useTranslation();

  return (
    <>
      <div className="rewards-title-wrapper">
        <div className="rewards-title">
          <p className="rewards-title-text">
            {t(T.REWARDS)}
          </p>
        </div>
      </div>
      <button type="button" className="rewards-close-button" onClick={onClose}>
        <i className="icon-close rewards-close-button-icon" />
      </button>
    </>
  );
};
